import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { LoadingBackdropProps } from '../types/MarksAnalyticsTypes';
import { ContentBox, StyledBackdrop } from '../styled';

const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({ open, message }) => {
  return (
    <StyledBackdrop open={open}>
      <ContentBox>
        <CircularProgress color='inherit' />
        {message && <Typography variant='body2'>{message}</Typography>}
      </ContentBox>
    </StyledBackdrop>
  );
};

export default LoadingBackdrop;
